import React from 'react';

function ProjectCard(props) {
    return (
        <div className="project_col">
            <a href={props.website} target="_blank" rel="noopener noreferrer">
                <div className="col">
                    <div className="project_img">

                        <p id="projectheading">{props.name}</p>
                        <p id="project_type">{props.type}</p>
                    </div>
                    <div className="project_description">
                        <p>
                            {props.info}
                        </p>
                    </div>
                </div>
            </a>
        </div>
    );
}
export default ProjectCard;